/* eslint-disable react/boolean-prop-naming */
import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const createImageMapMutation = gql`
  mutation CreateContentGroupImageMap(
    $projectId: String!
    $title: String!
    $iconAssetId: String!
  ) {
    contentGroup {
      createContentGroup(
        contentGroup: {
          projectId: $projectId
          title: $title
          type: IMAGE_MAP
          iconAssetId: $iconAssetId
        }
      ) {
        id
        title
        description
        url
        contentPages {
          id
          contentSections {
            id
            sectionContainers {
              id
            }
          }
        }
      }
    }
  }
`;

const createImageMap = ({
  projectId,
  title,
  iconAssetId,
  onError,
  onSuccessResult,
}) => (
  <Mutation mutation={createImageMapMutation}>
    {(createContentGroup, { loading, error, data }) => {
      const variables = {
        projectId,
        title,
        iconAssetId,
      };
      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(data.contentGroup.createContentGroup);
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={createContentGroup}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

createImageMap.propTypes = {
  iconAssetId: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default createImageMap;
